import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-item-specs" }
const _hoisted_2 = { class: "c-item-specs__spec__term" }
const _hoisted_3 = { class: "c-item-specs__spec__description" }
const _hoisted_4 = {
  key: 0,
  class: "c-item-specs__spec"
}
const _hoisted_5 = { class: "c-item-specs__spec__term" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specs, (spec, specKey) => {
      return (_openBlock(), _createElementBlock("dl", {
        class: "c-item-specs__spec",
        key: specKey
      }, [
        _createElementVNode("dt", _hoisted_2, _toDisplayString(spec.term) + "：", 1),
        _createElementVNode("dd", _hoisted_3, _toDisplayString(spec.description), 1)
      ]))
    }), 128)),
    (_ctx.qty)
      ? (_openBlock(), _createElementBlock("dl", _hoisted_4, [
          _createElementVNode("dt", _hoisted_5, "個数: " + _toDisplayString(_ctx.qty), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}